import React from "react"
import { connect } from "react-redux"

import * as actions from "../actions"

import TransitionedEdit from "./TransitionedEdit"
import * as generator from "../../chatItemGenerator"
import { pushRoute } from "../../common/route"
import ChatBubble from "./ChatBubble"
import MediaBubble from "./MediaBubble"
import { injectIntl } from "react-intl"

const NO_EDIT_TYPES = [
  "quizletQues",
  "screeningScreenOutQuestion",
  "intentSeekingCare",
  "intentCareOptions",
  "specialistIntentCareOptions",
  "diagnosisConcern",
  "dxocPromptQuestion",
]

const SCF_NO_EDIT_TYPES = [
  "cardinalQuestion",
  "identity",
  "sex",
  "age"
]

const ChatImage = ({ image, ...props }) => (
  <ChatItem {...props} item={generator.image(image)} prev={props.item} />
)

const ChatItem = props => {
  let { item, completed, prev, isProfile, intl, simpleFlowInterviewType } = props
  let { type, text, image, index, isFeedback } = item
  let formatMessage = intl && intl.formatMessage
  // For supporting different languages, if the text has an id, it is translatable
  if (text && text.id && formatMessage) {
    text = formatMessage(text)
  } else;
  if (Array.isArray(text) && text[0].id && formatMessage) {
    text = formatMessage(text[0], text[1])
  }

  let isResponse = item.type === "response"
  let showBrand = prev
    ? isResponse !== (prev.type === "response") ||
      prev.type === "symptomBubble" ||
      prev.type === "completion" ||
      prev.type === "specialistIntentCareOptions" ||
      prev.type === "diagnosisConcern" ||
      prev.type === "dxocCloseMessage"
    : true
  return (
    <div id={`chat-item-${item.index}`}>
      {type === "image" ? (
        <MediaBubble
          media={typeof image === "string" ? image : image[0]}
          blur={prev.blur}
          index={prev.index}
        />
      ) : (
        <ChatBubble
          brand={showBrand}
          question={!isResponse}
          text={text}
          isProfile={isProfile}
          {...props}
        />
      )}
      <TransitionedEdit
        show={
          type === "response" &&
          (!completed || isFeedback) &&
          !NO_EDIT_TYPES.contains(prev.type) &&
          !(SCF_NO_EDIT_TYPES.contains(prev.type) && simpleFlowInterviewType)
        }
        index={index}
        isLast={props.isLastResponse}
      />
      {type !== "image" &&
        image &&
        image.length &&
        !(text && text.indexOf("[") > 0) && (
          <ChatImage {...props} image={image} />
        )}
    </div>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  linkClick: () => {
    let { link, type } = ownProps.item

    if (link === "/restart") {
      dispatch(actions.startOver())
      window.scrollTo(0, 0)
    } else if (type === "integrationQues") {
      window.open(link)
    } else {
      pushRoute(link, true)
    }
  },

  imageLinkClick: title =>
    dispatch(actions.setActiveImage(ownProps.item.image)),
})

const mapStateToProps = state => ({
  // Since this flag is used to disable editing for certain chat items
  // we cannot use the simpleFlow.active because that is unset once we leave the
  // normal flow
  simpleFlowInterviewType: state.simpleFlow.diagnosis !== "",
})

const ChatItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ChatItem))

export { ChatItemContainer as default, ChatItem }



// WEBPACK FOOTER //
// ./assets/interview/components/ChatItem.js